import React from "react";
import { Typography, Box } from "@mui/material";
import image1 from "../../../iamges/Automated.png";
import image2 from "../../../iamges/Real-time.png";
import image3 from "../../../iamges/Legal Notice.png";
import image4 from "../../../iamges/Reminder Schedules.png";
import image5 from "../../../iamges/Onboarding tenant link.png";
import image6 from "../../../iamges/tax-report.jpg";
import imageSide from "../../../iamges/checklist.png";
import landlords from "../../../iamges/landlords.png";
import "./ActionsList.scss";
import CheckBadgeIcon from "../../../iamges/CheckBadgeIcon";
import ScrollWordReveal from "../ScrollWordReveal";

const ActionsList = () => {
  const list = [
    {
      image: image1,
      greenLine1: "",
      greenBgLine: "Automated",
      greenLine2: "Rent payment reminders",
      description:
        "Never miss a due date again. Our system sends automated rent reminders to your tenants via email, and in-app notifications. Stay consistent and professional without the awkward conversations.",
    },
    {
      image: image2,
      greenLine1: "",
      greenBgLine: "Real-Time",
      greenLine2: "Tenant Payment Tracking",
      description:
        "Track who paid, who's late, and what's pending - all from one dashboard.\nBuilt specifically for Canadian landlords, our rent tracking software provides real-time insights into payment statuses, overdue balances, and late payments across all your properties.",
    },
    {
      image: image3,
      greenLine1: "Get",
      greenBgLine: "Legal Notice Templates",
      greenLine2: "for Late Rent",
      description:
        "Missed rent? You're covered. HomeOwner provides legal rent notice templates designed for Canadian landlords, aligned with residential tenancy rules by province.\nGenerate late rent notices, standard eviction notices, and province-specific tenant eviction forms - all designed to help you act correctly and legally.",
    },
    {
      image: image4,
      greenLine1: "Customizable",
      greenBgLine: "Reminder Schedules",
      greenLine2: "",
      description:
        "You stay in control. Customize reminders before the due date, on the due date, or after - based on tenant payment behavior.\nThis flexibility makes HomeOwner a powerful online rent management software choice for Canadian landlords who want automation without losing control.",
    },
    {
      image: image5,
      greenLine1: "Find the Best Tenant Using",
      greenBgLine: " Our Onboarding tenant link",
      greenLine2: "",
      description:
        "Tired of rental applications scattered across messages and emails?\nUse our onboarding application to collect and review prospective tenants in one secure place. This helps Canadian landlords streamline the screening process and find the right fit - all directly from inside the app.",
    },
    {
      image: image6,
      greenLine1: "Track expenses.",
      greenBgLine: "Get a year-end",
      greenLine2: "tax report.",
      description:
        "Log every property expense as it happens, from repairs and utilities to insurance and property tax, sorted into the right categories. See your income, expenses, and net position for each property, updated through the year. At tax time, download a clean year-end report mapped to CRA Form T776, ready to hand your accountant.",
      smallNote: "Tax report download is $2.99 per property, per year.",
    },
  ];

  const renderChecklist = (item: string) => {
    return (
      <li className='checklist-item'>
        <div style={{ width: 26 }}>
          <CheckBadgeIcon size={26} style={{ paddingRight: 8 }} />
        </div>
        {item}
      </li>
    );
  };

  return (
    <>
      <div className='landlord-legal-awareness-container'>
        <div className='landlord-legal-awareness-content'>
          <div>
            <h2 className='landlord-legal-awareness-title'>
              Did you know many Canadian landlords are not aware of formal legal
              actions?
            </h2>
            <div className='landlord-legal-awareness-list'>
              <div className='landlord-legal-awareness-item'>
                <h3 className='landlord-legal-awareness-item-title'>
                  Unclear landlord-tenant laws
                </h3>
                <p className='landlord-legal-awareness-item-description'>
                  Many Canadian landlords are unsure about province-specific
                  landlord-tenant laws and the correct legal steps for late rent
                  or eviction.
                </p>
              </div>
              <div className='landlord-legal-awareness-item'>
                <h3 className='landlord-legal-awareness-item-title'>
                  Missed or delayed rent follow-ups
                </h3>
                <p className='landlord-legal-awareness-item-description'>
                  Discomfort with payment conversations or lack of reminders
                  often leads to missed rent follow-ups and growing arrears.
                </p>
              </div>
              <div className='landlord-legal-awareness-item'>
                <h3 className='landlord-legal-awareness-item-title'>
                  Incorrect or informal actions
                </h3>
                <p className='landlord-legal-awareness-item-description'>
                  Without proper legal notice templates, landlords risk sending
                  invalid notices that don’t comply with Canadian tenancy rules.
                </p>
              </div>
            </div>
          </div>
          <img src={landlords} alt='app' />
        </div>
      </div>

      <div className='ActionsList'>
        <ScrollWordReveal
          text='HomeOwner Rental helps you stay informed, organized, and legally prepared — without uncomfortable conversations or guesswork.'
          minOpacity={0.15}
          softness={1.2}
          stickyTop='18vh'
        />

        <div className='actions-list list-wrapper'>
          {list.map((item, index) => {
            const isReverse = index % 2 !== 0;
            return (
              <Box
                key={item.greenBgLine}
                className={`action-item ${isReverse ? "reverse" : ""}`}>
                {/* Image */}
                <div className='action-image'>
                  <img src={item.image} alt={`feature-${index}`} />
                </div>

                {/* Text */}
                <div className='action-text'>
                  {item.greenLine1 && (
                    <Typography variant='subtitle1' className='subtitle1'>
                      {item.greenLine1}
                    </Typography>
                  )}

                  <Typography component='div' className='highlight'>
                    {item.greenBgLine}
                  </Typography>

                  {item.greenLine2 && (
                    <Typography variant='subtitle1' className='line2'>
                      {item.greenLine2}
                    </Typography>
                  )}

                  <Typography variant='body2' className='description'>
                    {item.description}
                  </Typography>

                  {item?.smallNote && (
                    <Typography variant='caption' className='small-note'>
                      {item.smallNote}
                    </Typography>
                  )}
                </div>
              </Box>
            );
          })}
        </div>
      </div>

      <div className='moving-stress-section'>
        <div className='moving-stress-text'>
          <h2>Moving, buying, or selling?</h2>
          <p>Explore your HomeOwner tools for every step!</p>

          <ul className='checklist'>
            {renderChecklist("MOVING HOME CHECKLIST")}
            {renderChecklist("BUYING HOME CHECKLIST")}
            {renderChecklist("SELLING HOME CHECKLIST")}
            {renderChecklist(
              "GET ACCESS TO ALL NEARBY SERVICES AROUND YOUR AREA",
            )}
          </ul>

          <a href='/homeowner' className='know-more'>
            Know more →
          </a>
        </div>

        <div className='moving-stress-image'>
          <img src={imageSide} alt='app' />
        </div>
      </div>
    </>
  );
};

export default ActionsList;
